import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { DownloadService } from '~/api/services/downloadFiles'
import { FarmersService } from '~/api/services/farmers'
import { FormFields } from '~/components/FormFields'
import Layout from '~/components/Layout'
import { El } from '~/components/Layout/style'
import notify from '~/components/Notify'
import TableComponent from '~/components/TableComponent'
import { FarmersQuery } from '~/QueryHooks/Farmers'
import { handleErrors } from '~/utils/helpers'

const MgaDetails:React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const actions = [
    {
      popupMessage: t('Download'),
      type: 'icon',
      name: 'file pdf',
      size: 'large',
      actionType: 'pdf-results'
    }
  ]
  const tableColumnHeaders = [
    {
      name: t('Billing Month'),
      key: 'billingMonth',
      type: 'date',
      format: 'MMM YYYY'
    },
    {
      name: t('Amount (in kg)'),
      key: 'amountInKg',
      type: 'no-unit-number',
      decimalScale: 0
    },
    {
      name: t('Net total (in €)'),
      key: 'netTotal',
      type: 'no-unit-number'
    },
    {
      name: t('Gross total (in €)'),
      key: 'grossTotal',
      type: 'no-unit-number'
    },
    {
      name: t('Payout amount (in €)'),
      key: 'total',
      type: 'no-unit-number'
    },
    {
      name: t('Actions')
    }
  ]

  const [loadingAction, setLoadingAction] = useState({
    type: '',
    id: null,
    value: false,
    idKey: ''
  })
  const [dataFiltered, setDataFiltered] = useState({
    rows: 10,
    page: 0
  })
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)

  const { control, handleSubmit, reset } = useForm({
    mode: 'onChange'
  })

  const {
    data: mgaDetails,
    isLoading: isLoadingDetails,
    isFetching: isFetchingData,
    refetch: fetchData
  } = FarmersQuery.getMgaDetails(id, dataFiltered)

  const {
    data: mgaData,
    isLoading: isLoadingData
  } = FarmersQuery.getMgaDetailsData(id)

  useEffect(() => {
    fetchData()
  }, [dataFiltered])

  useEffect(() => {
    reset(mgaData)
  }, [mgaData])

  async function handleDownloadPdf(idInvoice) {
    setLoadingAction({
      type: 'pdf-results',
      id: idInvoice,
      value: true,
      idKey: 'id'
    })
    try {
      await DownloadService.downloadFileWithName(`farmers/${id}/milk-payment/invoices/${idInvoice}/preview/pdf`)
    } catch (error) {
      if (error.response.data) {
        // notify(error.response.data.message, 'error');
      } else {
        // notify(t('General error'), 'error');
      }
    }
    setLoadingAction({
      type: '',
      id: null,
      value: false,
      idKey: ''
    })
  }

  function handleActionClick(row, type) {
    switch(type) {
      case 'pdf-results':
        return handleDownloadPdf(row?.id)
      default:
        return
    }
  }

  function renderMgaDetails() {
    return <TableComponent
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      isFetchingData={isFetchingData}
      animated
      rows={rows}
      actions={actions}
      loadingAction={loadingAction}
      handleClickAction={(row, type) => handleActionClick(row, type)}
      total={filtered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
    />
  }
  
  async function onSubmit(data) {
    setIsLoadingSubmit(true)
    try {
      await FarmersService.updateMgaDetails(id, data)
      notify(t('Successfully update MGA details'), 'success')
    }catch(error) {
      handleErrors(error)
    }
    setIsLoadingSubmit(false)
  }

  function renderForm() {
    return <div
      style={{ display: 'flex', gap: 20, alignItems: 'center', marginBottom: '1em' }}
    >
      <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
        <label>{t('LKV/MPR Pin')}</label>
        <FormFields.Input
          control={control}
          loading={isLoadingSubmit}
          disabled={isLoadingSubmit}
          style={{ maxWidth: 300 }}
          styleLabel={{ width: '-webkit-fill-available' }}
          labelPosition='left'
          placeholder={t('Enter LKV/MPR Pin')}
          name={'mprPin'}
          rules={{
            maxLength: {
              value: 10,
              message: t('Max char. is 10!')
            }
          }}
        />
      </div>
      <div>{`${t('MSW')}: ${mgaData?.truckNumber || 0} / ${t('Tour')}: ${mgaData?.tourNumber || 0} / ${t('Order')}: ${mgaData?.order || 0}`}</div>
      <FormFields.Checkbox
        label={t('Dont create an MGA printout?')}
        disabled={isLoadingSubmit}
        checkboxValue={1}
        defaultValue={0}
        control={control}
        name={'excludeFromMgaPrint'}
      />
    </div>
  }

  function renderActions() {
    return <El.PageHeaderActionButton disabled={isLoadingSubmit}>
      {t('Update')}
    </El.PageHeaderActionButton>
  }

  const { filtered, rows } = mgaDetails ? mgaDetails : { filtered: 0, rows: [] }
  const isLoading = isLoadingData || isLoadingDetails

  return <Layout
    useSpinner
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    isBusy={isLoading}
    title={t('MGA details')}
    onSubmit={handleSubmit(onSubmit)}
    actions={renderActions()}
  >
    {renderForm()}
    {renderMgaDetails()}
  </Layout>
}
export default MgaDetails